/**
 * Cross-domain badge tone classes used by the shared `<StatusBadge>`
 * component (dashboard, knowledge-base, history, and results all read
 * it). Stays in `components/shared/` because the consumer
 * (`components/shared/StatusBadge.tsx`) is itself a cross-domain
 * shared component, not a results-only one.
 *
 * The results-only badge tones (`DEFAULT_BADGE_TONE`,
 * `reportClassificationBadgeTones`, `reportSeverityBadgeTones`,
 * `alignmentBadgeTones`, `evidenceSourceBadgeTones`) were moved out
 * to `features/results/{report-section-badge-tones,alignment-badge-tones,
 * evidence-source-badge-tones}.ts` in pirx-ojst0.12.
 */

import type { AuditStatus } from "@/types";

export const statusBadgeTones: Record<AuditStatus, string> = {
  UPLOADING:
    "border-[color:color-mix(in_srgb,var(--primary)_35%,transparent)] bg-[color:color-mix(in_srgb,var(--primary)_16%,var(--card))] text-[var(--foreground)]",
  QUEUED:
    "border-[color:color-mix(in_srgb,var(--primary)_28%,var(--border))] bg-[color:color-mix(in_srgb,var(--accent-foreground)_14%,var(--card))] text-[var(--foreground)]",
  PROCESSING:
    "border-[color:color-mix(in_srgb,var(--risk-medium)_35%,transparent)] bg-[color:color-mix(in_srgb,var(--risk-medium)_18%,var(--card))] text-[var(--foreground)]",
  COMPLETED:
    "border-[color:color-mix(in_srgb,var(--risk-low)_35%,transparent)] bg-[color:color-mix(in_srgb,var(--risk-low)_16%,var(--card))] text-[var(--foreground)]",
  FAILED:
    "border-[color:color-mix(in_srgb,var(--risk-high)_35%,transparent)] bg-[color:color-mix(in_srgb,var(--risk-high)_16%,var(--card))] text-[var(--foreground)]",
};
